import { styled } from "styled-components";
import {
  AssistantInfo,
  Footer,
  Header,
  Loader,
  SystemResponse,
  Timestamp,
  UserResponse,
} from "../../";

export const Container = styled.div(({ theme }) => {
  return {
    position: "relative",
    display: "flex",
    overflow: "hidden",
    flexDirection: "column",
    backgroundColor: theme.colors.white,
    height: "100%",

    [`& > ${Loader}`]: {
      margin: "auto",
    },

    [`& ${Header.Container}`]: {
      animation: "fadeIn 150ms ease-out 300ms forwards",
    },

    [`& ${Footer.Container}`]: {
      animation: "fadeIn 300ms ease-out 300ms forwards",
    },
  };
});

export const Status = styled.div(({ theme }) => {
  return {
    display: "flex",
    justifyContent: "center",
    fontSize: 12,
    color: theme.colors.grayDark,
  };
});

export const SessionTime = styled.span(({ theme }) => {
  return {
    display: "flex",
    justifyContent: "center",
    fontSize: 12,
    color: theme.colors.grayDark,
    paddingBottom: theme.space[3],
  };
});

export const Dialog = styled.div(({ theme }) => {
  return {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflowY: "scroll",
    overflowX: "hidden",
    padding: `0 ${theme.space[5]} ${theme.space[3]} ${theme.space[5]}`,

    [`
    & ${UserResponse.Container},
    & ${SystemResponse.Actions},
    & ${AssistantInfo.Container}
  `]: {
      animation: "fadeIn 150ms ease-out 0ms forwards",
    },

    [`& > ${SystemResponse.Actions}`]: {
      padding: `0 ${theme.space[5]} 0 54px`,
    },

    [`& ${SystemResponse.Container}`]: {
      marginBottom: theme.space[1],

      "&:last-of-type": {
        marginBottom: 0,
      },
    },

    [`& ${UserResponse.Container} + ${UserResponse.Container}`]: {
      marginTop: theme.space[1],
    },

    [`
    & ${SystemResponse.Container} + ${UserResponse.Container},
    & ${SystemResponse.Actions} + ${UserResponse.Container},
    & ${UserResponse.Container} + ${SystemResponse.Container}
  `]: {
      marginTop: theme.space[4],
    },

    [`& ${Timestamp.Container}`]: { width: 50 },

    [`& ${Status}`]: {
      marginTop: theme.space[3],
      marginBottom: 8,
    },
  };
});

/** Empty div with flexGrow = 1 to take empty space */
export const Spacer = styled.div({
  flexGrow: 1,
});
